import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../Auth';
import { AnimatePresence, motion } from 'framer-motion';
import Logo from '../components/shared/Logo';

const PublicLayout = () => {
  const { user } = useAuth();
  const location = useLocation();

  // Allow authenticated users to stay on the verify-email page
  const isVerifyEmailPage = location.pathname === '/auth/verify-email';

  if (user != null && !isVerifyEmailPage) {
    return <Navigate to="/home" />;
  }

  return (
    <div className="min-h-dvh bg-surface flex flex-col">
      <AnimatePresence mode="wait">
        <motion.div
          key={location.pathname}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5 }}
          className="flex-1"
        >
          <Outlet />
        </motion.div>
      </AnimatePresence>

      {/* Hide footer on verify-email page */}
      {!isVerifyEmailPage && (
        <footer className="p-10 bg-surface-container-low border-t border-outline-variant/5">
          <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <Logo className="h-8" variant="invert" />
              </div>
              <p className="text-on-surface-variant/40 text-sm">The production workspace for comics and episodic shows.</p>
            </div>

            <div>
              <h3 className="text-on-surface font-semibold mb-3">Features</h3>
              <div className="flex flex-col gap-2">
                <a href="#" className="text-on-surface-variant/60 hover:text-tertiary transition-colors text-sm">Writing</a>
                <a href="#" className="text-on-surface-variant/60 hover:text-tertiary transition-colors text-sm">Process</a>
                <a href="#" className="text-on-surface-variant/60 hover:text-tertiary transition-colors text-sm">Planning</a>
              </div>
            </div>
            <div>
              <h3 className="text-on-surface font-semibold mb-3">Company</h3>
              <div className="flex flex-col gap-2">
                <a href="#" className="text-on-surface-variant/60 hover:text-tertiary transition-colors text-sm">About us</a>
                <a href="#" className="text-on-surface-variant/60 hover:text-tertiary transition-colors text-sm">Contact</a>
                <a href="#" className="text-on-surface-variant/60 hover:text-tertiary transition-colors text-sm">Press kit</a>
              </div>
            </div>
            <div>
              <h3 className="text-on-surface font-semibold mb-3">Legal</h3>
              <div className="flex flex-col gap-2">
                <a href="#" className="text-on-surface-variant/60 hover:text-tertiary transition-colors text-sm">Terms of use</a>
                <a href="#" className="text-on-surface-variant/60 hover:text-tertiary transition-colors text-sm">Privacy policy</a>
                <a href="#" className="text-on-surface-variant/60 hover:text-tertiary transition-colors text-sm">Cookie policy</a>
              </div>
            </div>
          </div>
        </footer>
      )}
    </div>
  );
};

export default PublicLayout;